import axios from "axios";
import { ResponseAPIModel } from "../../../../setup/models/ResponseAPIModel";
import { LinkPaymentModel } from "../../linkpayment/models"
import { BinInstallmentModel } from "../../payment/models/BinInstallmentModel";
import { PaymentModel } from "../../payment/models";

const API_URL = process.env.REACT_APP_API_URL || '/api'

export const LINKPAYMENT_GET_URL = `${API_URL}/public/link-payment`;
export const POST_INSTALLEMENT = `${API_URL}/public/link-payment/get-installment`;
export const POST_LINKPAYMENT_3DS = `${API_URL}/public/link-payment/pay`;

export function linkPaymentGet(token: string) {
    return axios.get<ResponseAPIModel<LinkPaymentModel>>(`${LINKPAYMENT_GET_URL}/${token}`);
}

export function getInstallment(token: string, requestBody: { bin: string; amount: number }) {
    return axios.post<ResponseAPIModel<BinInstallmentModel>>(`${POST_INSTALLEMENT}/${token}`, requestBody);
}

export function linkPaymentPay(token: string, model: PaymentModel) {
    return axios.post<ResponseAPIModel<string>>(`${POST_LINKPAYMENT_3DS}/${token}`, model);
}